var _excluded = ["group", "onItemSelect"],
    _excluded2 = ["macros", "loading"],
    _excluded3 = ["types", "options", "customOptions", "inputTrigger", "onSelect", "hideToggle", "children", "disabled", "validOptionTypes"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import * as React from 'react';
import './macro-manager.scss';
import clone from 'clone-deep';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import Icon, { Loading3QuartersOutlined } from '@ant-design/icons';
import { Popover, Input } from 'antd';
import * as randomstring from 'randomstring';
import { IconMacro } from '../svg/icon-macro';
import { BetterInput } from '../better-input/better-input';
import { resolvePromiseableProp, isPromise, getClassNames, escapeRegExpString as esc, fireNativeInputChangeEvent } from '../../utils';
import { EcommItemType } from '../../enums/ecomm-item-type';
var MacroOptions = {
  domain: {
    label: 'Domain',
    options: [{
      label: 'Domain ID',
      value: 'domain_id'
    }, {
      label: 'Domain URL',
      value: 'domain_url'
    }]
  },
  device: {
    label: 'Device',
    options: [{
      label: 'Type',
      value: 'profile.placement'
    }]
  },
  notification: {
    label: 'Notification',
    options: [{
      label: 'Notification ID',
      value: 'notification_id'
    }, {
      label: 'Notification Title',
      value: 'notification_title'
    }, {
      label: 'Notification Body',
      value: 'notification_body'
    }, {
      label: 'Segment IDs',
      value: 'segment_ids'
    }, {
      label: 'Segment Names',
      value: 'segment_names'
    }, {
      label: 'Keywords',
      value: 'keywords'
    }, {
      label: 'Notification Source (Manual, Feed)',
      value: 'notification_source'
    }, {
      label: 'Delivery Type (Immediate, Scheduled)',
      value: 'delivery_type'
    }]
  },
  location: {
    label: 'Location',
    options: [{
      label: 'City',
      value: 'profile.city'
    }, {
      label: 'Province',
      value: 'profile.province'
    }, {
      label: 'Country Code',
      value: 'profile.country_code'
    }]
  },
  ecomm: {
    label: 'E-Commerce Item',
    options: [{
      label: 'ID',
      value: 'item.item_id',
      option_types: [EcommItemType.EVENT, EcommItemType.PRODUCT]
    }, {
      label: 'Name',
      value: 'item.name',
      option_types: [EcommItemType.EVENT, EcommItemType.PRODUCT]
    }, {
      label: 'Description',
      value: 'item.description',
      option_types: [EcommItemType.EVENT, EcommItemType.PRODUCT]
    }, {
      label: 'Landing URL',
      value: 'item.url',
      option_types: [EcommItemType.EVENT, EcommItemType.PRODUCT]
    }, {
      label: 'Image URL',
      value: 'item.image',
      option_types: [EcommItemType.EVENT, EcommItemType.PRODUCT]
    }, {
      label: 'Price',
      value: 'item.price',
      option_types: [EcommItemType.EVENT, EcommItemType.PRODUCT]
    }, // PRODUCT
    {
      label: 'Brand Name',
      value: 'item.brand_name',
      option_types: [EcommItemType.PRODUCT]
    }, // EVENT
    {
      label: 'Event Start Date',
      value: 'item.date_start',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Event End Date',
      value: 'item.date_end',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Genre: Major',
      value: 'item.genre_major',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Genre: Minor',
      value: 'item.genre_minor',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Performer Name',
      value: 'item.performer_name',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Performer URL',
      value: 'item.performer_url',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Performer Image URL',
      value: 'item.performer_image',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Venue ID',
      value: 'item.location_id',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Venue Name',
      value: 'item.location_name',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Venue City',
      value: 'item.location_city',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Venue Region',
      value: 'item.location_region',
      option_types: [EcommItemType.EVENT]
    }, {
      label: 'Venue Country',
      value: 'item.location_country',
      option_types: [EcommItemType.EVENT]
    }]
  },
  custom: {
    label: 'Custom',
    options: []
  }
};
var BASE_CLASSNAME = 'macro-manager';
var DEFAULT_INPUT_TRIGGER = '{{.}}';

var getMacroOptions = function getMacroOptions(_ref) {
  var types = _ref.types,
      options = _ref.options,
      customOptions = _ref.customOptions,
      validOptionTypes = _ref.validOptionTypes;
  var macroOptions = clone(MacroOptions);

  if (_typeof(options) === 'object' && !isPromise(options)) {
    macroOptions = options;
  }

  if (Array.isArray(customOptions)) {
    macroOptions.custom = {
      label: 'Custom',
      options: customOptions
    };
  }

  var visibleTypes = types !== null && types !== void 0 ? types : ['domain', 'device', 'location', 'ecomm', 'custom'];
  var macroGroups = [];

  var _iterator = _createForOfIteratorHelper(visibleTypes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var type = _step.value;
      var typeConfig = macroOptions[type];

      if (!typeConfig) {
        continue;
      }

      var group = {
        label: typeConfig.label,
        options: []
      };

      var _iterator2 = _createForOfIteratorHelper(typeConfig.options),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var opt = _step2.value;

          if (validOptionTypes && validOptionTypes.length > 0 && opt.option_types && !opt.option_types.some(function (ot) {
            return validOptionTypes.includes(ot);
          })) {
            // if valid option types is provided do not return any option that does not have one of those types
            continue;
          }

          group.options.push(opt);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (group.options.length > 0) {
        macroGroups.push(group);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return macroGroups;
};

var MacroOption = function MacroOption(_ref2) {
  var _context$macro, _context$macro$value;

  var macro = _ref2.macro,
      _onClick = _ref2.onClick,
      context = _ref2.context;
  var isActive = (context === null || context === void 0 ? void 0 : (_context$macro = context.macro) === null || _context$macro === void 0 ? void 0 : (_context$macro$value = _context$macro.value) === null || _context$macro$value === void 0 ? void 0 : _context$macro$value.trim()) === macro.value.trim();
  return /*#__PURE__*/React.createElement("li", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-item"), _defineProperty({}, 'active', isActive)),
    onClick: function onClick(e) {
      e.preventDefault();

      _onClick(macro);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "label"
  }, macro.label), isActive && /*#__PURE__*/React.createElement("span", {
    className: "active-indicator"
  }, /*#__PURE__*/React.createElement(LegacyIcon, {
    type: "check"
  })));
};

var MacroOptionGroup = function MacroOptionGroup(_ref3) {
  var group = _ref3.group,
      onItemSelect = _ref3.onItemSelect,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement("li", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-group"))
  }, /*#__PURE__*/React.createElement("span", {
    className: "heading"
  }, group.label), /*#__PURE__*/React.createElement("ul", null, group.options.map(function (macro, idx) {
    return /*#__PURE__*/React.createElement(MacroOption, _extends({
      key: idx,
      macro: macro,
      onClick: onItemSelect
    }, props));
  })));
};

var MacroOptionsList = function MacroOptionsList(_ref4) {
  var macros = _ref4.macros,
      loading = _ref4.loading,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return /*#__PURE__*/React.createElement("ul", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-item-list"))
  }, loading && /*#__PURE__*/React.createElement("li", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-group"))
  }, /*#__PURE__*/React.createElement("span", {
    className: "heading"
  }, /*#__PURE__*/React.createElement(Loading3QuartersOutlined, {
    spin: true
  }), /*#__PURE__*/React.createElement("span", null, " Loading"))), macros.map(function (group, idx) {
    return /*#__PURE__*/React.createElement(MacroOptionGroup, _extends({
      key: idx,
      group: group
    }, props));
  }));
};

var MacroOptionsListToggle = function MacroOptionsListToggle(_ref5) {
  var onClick = _ref5.onClick,
      loading = _ref5.loading,
      hideToggle = _ref5.hideToggle;
  return /*#__PURE__*/React.createElement("span", {
    className: getClassNames("".concat(BASE_CLASSNAME, "-macro-toggle"), _defineProperty({}, 'hidden', hideToggle))
  }, /*#__PURE__*/React.createElement(Icon, {
    component: IconMacro,
    onClick: onClick
  }));
};
/**
 * Example start sequence: (?<!{){{(?:(?!{|}}).)*$
 * Example end sequence: ^(?:(?<!}|{{).)*}}(?!})
 */


var getInputContext = function getInputContext(input, trigger) {
  var _trigger$split = trigger.split('.'),
      _trigger$split2 = _slicedToArray(_trigger$split, 2),
      tStart = _trigger$split2[0],
      tEnd = _trigger$split2[1];

  var seq = {
    start: new RegExp("(?<!".concat(esc(tStart[0]), ")").concat(esc(tStart), "(?:(?!").concat(esc(tStart[0]), "|").concat(esc(tEnd), ").)*$")),
    end: new RegExp("^(?:(?<!".concat(esc(tEnd[0]), "|").concat(esc(tStart), ").)*").concat(esc(tEnd), "(?!").concat(esc(tEnd[0]), ")"))
  };
  var value = input.value;
  var cursorPos = input.selectionStart;
  var _ref6 = [value.slice(0, cursorPos), value.slice(cursorPos)],
      vStart = _ref6[0],
      vEnd = _ref6[1];
  var tStartPos = null;
  var startMatch = vStart.match(seq.start);

  if (startMatch) {
    tStartPos = startMatch.index;
  }

  var tEndPos = null;
  var endMatch = vEnd.match(seq.end);

  if (endMatch) {
    tEndPos = vStart.length + endMatch[0].indexOf(tEnd);
  }

  var macroConfig = null;

  if (tStartPos) {
    var _tEndPos;

    macroConfig = {
      startTrigger: tStart,
      startPos: tStartPos,
      endTrigger: tEnd,
      endPos: tEndPos,
      value: value.slice(tStartPos, (_tEndPos = tEndPos) !== null && _tEndPos !== void 0 ? _tEndPos : undefined).replace(tStart, '').replace(tEnd, '')
    };
  }

  return {
    input: {
      value: value,
      start: vStart,
      end: vEnd
    },
    macro: macroConfig,
    cursor: {
      cursorPos: cursorPos,
      inTrigger: !!macroConfig && tStartPos !== null && cursorPos >= tStartPos && (tEndPos === null || cursorPos <= tEndPos)
    },
    seq: {
      start: seq.start.compile(seq.start.source, seq.start.flags),
      end: seq.end.compile(seq.end.source, seq.end.flags)
    }
  };
};

export var MacroManager = /*#__PURE__*/function (_React$Component) {
  _inherits(MacroManager, _React$Component);

  var _super = _createSuper(MacroManager);

  function MacroManager(props) {
    var _this;

    _classCallCheck(this, MacroManager);

    _this = _super.call(this, props);
    _this.state = {
      showMacroOptions: false,
      loading: true,
      options: {},
      customOptions: []
    };
    _this.id = "mm-".concat(randomstring.generate({
      length: 5
    }));
    _this.inputComponentRef = void 0;
    _this.unmounting = false;

    _this.handleDocumentClick = function (ev) {
      var toEl = ev.toElement;

      if (toEl) {
        var update = {}; // determine if clicked element is inside
        // the current macro manager scope
        // only true external clicks should close

        var masterEl = toEl.closest("#".concat(_this.id));
        var overlayEl = toEl.closest(".".concat(_this.id));
        var shouldClose = !masterEl && !overlayEl; // computed blur evenst should clear
        // input state and hide macro options

        if (shouldClose) {
          update.showMacroOptions = false;
          update.inputContext = undefined;
        }

        _this.setState(update);
      }
    };

    _this.handleInputInteraction = function (ev) {
      var _ev$stopPropagation, _ev$stopImmediateProp;

      (_ev$stopPropagation = ev.stopPropagation) === null || _ev$stopPropagation === void 0 ? void 0 : _ev$stopPropagation.call(ev);
      (_ev$stopImmediateProp = ev.stopImmediatePropagation) === null || _ev$stopImmediateProp === void 0 ? void 0 : _ev$stopImmediateProp.call(ev);
      var showMacroOptions = false;
      var inputContext;

      try {
        var _this$props$inputTrig;

        var evType = ev.type;
        inputContext = getInputContext(ev.target, (_this$props$inputTrig = _this.props.inputTrigger) !== null && _this$props$inputTrig !== void 0 ? _this$props$inputTrig : DEFAULT_INPUT_TRIGGER); // a focus event while already open should ignore inTrigger state

        showMacroOptions = evType === 'focus' && _this.state.showMacroOptions ? true : inputContext.cursor.inTrigger;
      } catch (err) {
        console.warn('Error computing input state', err);
      }

      _this.setState(function () {
        return {
          showMacroOptions: showMacroOptions,
          inputContext: inputContext
        };
      });
    };

    _this.handleMacroMenuToggle = function (ev) {
      var _ev$stopPropagation2, _ev$stopImmediateProp2;

      (_ev$stopPropagation2 = ev.stopPropagation) === null || _ev$stopPropagation2 === void 0 ? void 0 : _ev$stopPropagation2.call(ev);
      (_ev$stopImmediateProp2 = ev.stopImmediatePropagation) === null || _ev$stopImmediateProp2 === void 0 ? void 0 : _ev$stopImmediateProp2.call(ev);

      _this.setState(function (_ref7) {
        var showMacroOptions = _ref7.showMacroOptions,
            inputContext = _ref7.inputContext;
        return {
          showMacroOptions: !showMacroOptions,
          inputContext: _objectSpread(_objectSpread({}, inputContext), {}, {
            macro: showMacroOptions ? null : inputContext === null || inputContext === void 0 ? void 0 : inputContext.macro
          })
        };
      }, function () {
        // if showMacroOptions is true refocus
        // the active input element to allow
        // continued typing
        if (_this.state.showMacroOptions) {
          _this.getInputElement().focus();
        }
      });
    };

    _this.handleSelect = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(macro) {
        var _this$props$trigger$t, _this$props$trigger, _this$props$padInputT, _el$selectionStart, _inputContext$macro$e, _el$selectionStart2, _this$props$onSelect, _this$props;

        var el, _split, _split2, tStart, tEnd, padInputTrigger, inputContext, startPos, endPos, trimStartSeq, trimEndSeq, newValueStart, newValueEnd, newValue;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                el = _this.getInputElement();
                _split = ((_this$props$trigger$t = (_this$props$trigger = _this.props.trigger) === null || _this$props$trigger === void 0 ? void 0 : _this$props$trigger.toString()) !== null && _this$props$trigger$t !== void 0 ? _this$props$trigger$t : DEFAULT_INPUT_TRIGGER).split('.'), _split2 = _slicedToArray(_split, 2), tStart = _split2[0], tEnd = _split2[1];
                padInputTrigger = (_this$props$padInputT = _this.props.padInputTrigger) !== null && _this$props$padInputT !== void 0 ? _this$props$padInputT : false; // calculate current positions based on
                // input context and activeMacro

                inputContext = _this.state.inputContext;
                startPos = !!(inputContext !== null && inputContext !== void 0 && inputContext.macro) ? inputContext.macro.startPos : (_el$selectionStart = el.selectionStart) !== null && _el$selectionStart !== void 0 ? _el$selectionStart : 0;
                endPos = !!(inputContext !== null && inputContext !== void 0 && inputContext.macro) ? (_inputContext$macro$e = inputContext.macro.endPos) !== null && _inputContext$macro$e !== void 0 ? _inputContext$macro$e : inputContext.macro.startPos : (_el$selectionStart2 = el.selectionStart) !== null && _el$selectionStart2 !== void 0 ? _el$selectionStart2 : 0; // using calculated positions the wrapped
                // macro value is injected into the current
                // value prop

                trimStartSeq = new RegExp("".concat(esc(tStart), "$"));
                trimEndSeq = new RegExp("^".concat(esc(tEnd)));
                newValueStart = el.value.slice(0, startPos).replace(trimStartSeq, '') + "".concat(tStart).concat(padInputTrigger ? ' ' : '').concat(macro.value).concat(padInputTrigger ? ' ' : '').concat(tEnd);
                newValueEnd = el.value.slice(endPos).replace(trimEndSeq, '') // workaround for trailing open tokens
                .replace(trimStartSeq, '');
                newValue = newValueStart + newValueEnd; // set value on component using
                // simulated native event

                fireNativeInputChangeEvent(el, newValue); // reset cursor position

                el.selectionStart = newValueStart.length;
                el.selectionEnd = newValueStart.length;
                el.focus();
                _context.next = 17;
                return _this.setState({
                  showMacroOptions: false
                });

              case 17:
                // fire any listening method
                (_this$props$onSelect = (_this$props = _this.props).onSelect) === null || _this$props$onSelect === void 0 ? void 0 : _this$props$onSelect.call(_this$props, macro);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref8.apply(this, arguments);
      };
    }();

    return _this;
  } // tslint:disable-next-line:function-name


  _createClass(MacroManager, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.configureInputElement();
      this.resolveOptions();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.wireComponentEvents();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev) {
      if (!prev.options && !!this.props.options || !prev.customOptions && !!this.props.customOptions) {
        this.resolveOptions();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmounting = true;
      this.unwireComponentEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$showMacro,
          _props$title,
          _inputRect$height,
          _inputRect$height2,
          _inputRect$height3,
          _getClassNames3,
          _this2 = this;

      var _this$props2 = this.props,
          types = _this$props2.types,
          options = _this$props2.options,
          customOptions = _this$props2.customOptions,
          inputTrigger = _this$props2.inputTrigger,
          onSelect = _this$props2.onSelect,
          hideToggle = _this$props2.hideToggle,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          validOptionTypes = _this$props2.validOptionTypes,
          props = _objectWithoutProperties(_this$props2, _excluded3);

      var InputComponent = React.Children.only(children);
      var visible = (_this$state$showMacro = this.state.showMacroOptions) !== null && _this$state$showMacro !== void 0 ? _this$state$showMacro : props.visible;
      var title = (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : 'Macros';
      var macroOptions = getMacroOptions({
        types: types,
        options: this.state.options,
        customOptions: this.state.customOptions,
        validOptionTypes: validOptionTypes
      });
      var input = this.getInputElement();
      var inputProps = this.getInputProps();
      var inputContext = this.state.inputContext;
      var inputRect = !input ? undefined : this.getInputElement().getBoundingClientRect(); // calculate popover Y adjustment based on element height

      var offsetY = (inputProps === null || inputProps === void 0 ? void 0 : inputProps.size) === 'small' ? ((_inputRect$height = inputRect === null || inputRect === void 0 ? void 0 : inputRect.height) !== null && _inputRect$height !== void 0 ? _inputRect$height : 24) + 8 : (inputProps === null || inputProps === void 0 ? void 0 : inputProps.size) === 'large' ? ((_inputRect$height2 = inputRect === null || inputRect === void 0 ? void 0 : inputRect.height) !== null && _inputRect$height2 !== void 0 ? _inputRect$height2 : 40) + 2 : ((_inputRect$height3 = inputRect === null || inputRect === void 0 ? void 0 : inputRect.height) !== null && _inputRect$height3 !== void 0 ? _inputRect$height3 : 32) + 4;
      var overlayStyle = props.overlayStyle;

      if (inputRect) {
        overlayStyle = _objectSpread(_objectSpread({}, props.overlayStyle), {}, {
          width: "".concat(inputRect.width, "px")
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        key: this.id,
        id: this.id,
        className: getClassNames(BASE_CLASSNAME, this.id, (_getClassNames3 = {}, _defineProperty(_getClassNames3, 'overlay-visible', visible), _defineProperty(_getClassNames3, 'hide-toggle', hideToggle), _defineProperty(_getClassNames3, "disabled", disabled), _getClassNames3))
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames("".concat(BASE_CLASSNAME, "-input-wrapper"))
      }, /*#__PURE__*/React.createElement(InputComponent.type, _extends({}, InputComponent.props, {
        ref: function ref(el) {
          // call initial ref method
          var _ref9 = InputComponent,
              ref = _ref9.ref;

          if (ref && typeof ref === 'function') {
            ref(el);
          } // set internal ref


          _this2.inputComponentRef = el;
        },
        className: getClassNames("".concat(BASE_CLASSNAME, "-input"), InputComponent.props.className)
      })), /*#__PURE__*/React.createElement(Popover, _extends({
        key: "".concat(this.id, "-macro-list")
      }, props, {
        className: getClassNames("".concat(BASE_CLASSNAME, "-control"), props.className, this.id, {}),
        visible: visible,
        title: /*#__PURE__*/React.createElement("div", {
          className: getClassNames("".concat(BASE_CLASSNAME, "-overlay-title"))
        }, /*#__PURE__*/React.createElement("span", {
          className: getClassNames("".concat(BASE_CLASSNAME, "-title"))
        }, title)),
        align: {
          // adjust for icon location and height
          points: ['tr', 'tr'],
          offset: [8, offsetY]
        },
        overlayClassName: getClassNames("".concat(BASE_CLASSNAME, "-overlay"), props.overlayClassName, this.id, {}),
        overlayStyle: overlayStyle,
        content: /*#__PURE__*/React.createElement(MacroOptionsList, {
          loading: this.state.loading,
          context: inputContext,
          macros: macroOptions,
          onItemSelect: this.handleSelect
        }),
        trigger: "click"
      }), /*#__PURE__*/React.createElement(MacroOptionsListToggle, {
        loading: this.state.loading,
        onClick: this.handleMacroMenuToggle,
        hideToggle: hideToggle
      }))));
    }
  }, {
    key: "isInputComponentStateful",
    value: function isInputComponentStateful() {
      var _this$inputComponentR;

      return !!((_this$inputComponentR = this.inputComponentRef) !== null && _this$inputComponentR !== void 0 && _this$inputComponentR.setState);
    }
    /**
     * Validates passed children to ensure single
     * element matching one of the following types:
     *   antd <Input />
     *   sw   <BetterInput />
     *   html <input />
     *
     */

  }, {
    key: "configureInputElement",
    value: function configureInputElement() {
      var child = React.Children.only(this.props.children);
      var isProperType = child.type === Input || child.type === BetterInput || child.type === 'input';

      if (!isProperType) {
        throw new Error('MacroManger child component must be type input or Input');
      }
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      var _this$inputComponentR2;

      return (_this$inputComponentR2 = this.inputComponentRef) === null || _this$inputComponentR2 === void 0 ? void 0 : _this$inputComponentR2.props;
    }
    /**
     * Returns the actual html input element
     * whether nested or direct
     *
     */

  }, {
    key: "getInputElement",
    value: function getInputElement() {
      var _this$inputComponentR3;

      var inputConstructor = (_this$inputComponentR3 = this.inputComponentRef) === null || _this$inputComponentR3 === void 0 ? void 0 : _this$inputComponentR3.constructor;
      return inputConstructor === Input || inputConstructor === BetterInput ? this.inputComponentRef.input : this.inputComponentRef;
    }
  }, {
    key: "wireComponentEvents",
    value: function wireComponentEvents() {
      var el = this.getInputElement();

      if (el) {
        el.addEventListener('focus', this.handleInputInteraction);
        el.addEventListener('keyup', this.handleInputInteraction);
        el.addEventListener('click', this.handleInputInteraction);
      }

      document.body.addEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "unwireComponentEvents",
    value: function unwireComponentEvents() {
      var el = this.getInputElement();

      if (el) {
        el.removeEventListener('focus', this.handleInputInteraction);
        el.removeEventListener('keyup', this.handleInputInteraction);
        el.removeEventListener('click', this.handleInputInteraction);
      }

      document.body.removeEventListener('click', this.handleDocumentClick);
    }
    /**
     * Determines whether click is blur or focus.
     * Uses component unique id to prevent collisions.
     *
     */

  }, {
    key: "resolveOptions",
    value:
    /**
     * Ensures options are set from static
     * or async sources and adjusts loading
     * state accordingly
     *
     */
    function () {
      var _resolveOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$props3, options, customOptions, resolvedOptions, resolvedCustomOptions;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props3 = this.props, options = _this$props3.options, customOptions = _this$props3.customOptions;

                if (options) {
                  _context2.next = 5;
                  break;
                }

                _context2.t0 = undefined;
                _context2.next = 8;
                break;

              case 5:
                _context2.next = 7;
                return resolvePromiseableProp(options);

              case 7:
                _context2.t0 = _context2.sent;

              case 8:
                resolvedOptions = _context2.t0;

                if (customOptions) {
                  _context2.next = 13;
                  break;
                }

                _context2.t1 = [];
                _context2.next = 16;
                break;

              case 13:
                _context2.next = 15;
                return resolvePromiseableProp(customOptions);

              case 15:
                _context2.t1 = _context2.sent;

              case 16:
                resolvedCustomOptions = _context2.t1;

                if (!this.unmounting) {
                  this.setState({
                    loading: false,
                    options: resolvedOptions,
                    customOptions: resolvedCustomOptions
                  });
                }

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function resolveOptions() {
        return _resolveOptions.apply(this, arguments);
      }

      return resolveOptions;
    }()
  }]);

  return MacroManager;
}(React.Component);